/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Post_ImageInputs */

const en_label_post_image = /** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hero Image`)
};

const es_label_post_image = /** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagen Principal`)
};

const fr_label_post_image = /** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image principale`)
};

const de_label_post_image = /** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titelbild`)
};

const id_label_post_image = /** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambar Hero`)
};

/** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */
const ja_label_post_image = en_label_post_image;

/** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */
const zh_label_post_image = en_label_post_image;

/** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */
const ar_label_post_image = en_label_post_image;

/** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */
const it_label_post_image = en_label_post_image;

/** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */
const ru_label_post_image = en_label_post_image;

/** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */
const pt_label_post_image = en_label_post_image;

/** @type {(inputs: Label_Post_ImageInputs) => LocalizedString} */
const ko_label_post_image = en_label_post_image;

/**
* | output |
* | --- |
* | "Hero Image" |
*
* @param {Label_Post_ImageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_post_image = /** @type {((inputs?: Label_Post_ImageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Post_ImageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_post_image(inputs)
	if (locale === "es") return es_label_post_image(inputs)
	if (locale === "fr") return fr_label_post_image(inputs)
	if (locale === "de") return de_label_post_image(inputs)
	if (locale === "ja") return ja_label_post_image(inputs)
	if (locale === "zh") return zh_label_post_image(inputs)
	if (locale === "ar") return ar_label_post_image(inputs)
	if (locale === "id") return id_label_post_image(inputs)
	if (locale === "it") return it_label_post_image(inputs)
	if (locale === "ru") return ru_label_post_image(inputs)
	if (locale === "pt") return pt_label_post_image(inputs)
	return ko_label_post_image(inputs)
});